import React, {Component} from 'react';
import {connect} from 'react-redux';
import Config from '../../config';
import '../../styles/channel/ChannelShareCard.css';

class LectureShareCard extends Component {
    constructor() {
        super();
        this.handleShareLink = this.handleShareLink.bind(this);
    }

    handleShareLink() {
        const {lectureId, account} = this.props;
        window.location = Config.MAIN_URL + `/lecture/get_share_card?lecture_id=${lectureId}&account_id=${account.id}`;
    }


    render() {
        return (
            <div className="channel-share-card ">
                <a className="default-hover" onClick={this.handleShareLink}>我的邀请卡</a>
            </div>
        )
    }
}

export default connect((state) => ({
    account: state.account,
    lectureId: state.lecture.lecture.id,
}))(LectureShareCard)


// WEBPACK FOOTER //
// ./src/components/lecture/LectureShareCard.js